// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"9b2df64b","453":"280c9fc1"}[chunkId] + ".chunk.js";
};